import { createStore, withProps } from "@ngneat/elf";
import { withRequestsStatus } from "@ngneat/elf-requests";
import { CompanyDetailsModel } from "./companyDetails.model";

export const companyDetailsStore = createStore({ name: "company-details" }, withProps<CompanyDetailsModel>({}), withRequestsStatus());
